import React, { useRef, useCallback } from 'react';

import PropTypes from 'prop-types';

import { Form, DateTime, Select, Combobox } from '~/components/Form';
import { t, number } from '~/helpers';

import * as S from './styles';

function Header({ minimo, meta, maximo, data, handleSubmit }) {
  const formRef = useRef(null);

  const handleAutoSubmit = useCallback(
    (fieldName) => (value) => {
      // Atualiza o campo alterado
      formRef.current.setFieldValue(fieldName, value);

      // Pega todos os dados e envia para handleSubmit manualmente
      const newData = formRef.current.getData();

      handleSubmit(newData);
    },
    [data]
  );

  return (
    <S.Wrapper>
      <S.WrapperTable>
        <table>
          <thead>
            <tr>
              <th>{t('s.indicadoroperacao.minimo')}</th>
              <th>{t('s.indicadoroperacao.meta')}</th>
              <th>{t('s.indicadoroperacao.maximo')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{number(minimo, 2)}</td>
              <td className="meta">{number(meta, 2)}</td>
              <td>{number(maximo, 2)}</td>
            </tr>
          </tbody>
        </table>
      </S.WrapperTable>

      <Form ref={formRef} initialData={data}>
        <S.WrapperForm>
          {/* <Select
            name="tipo"
            options={[
              { value: 'ambiente', label: 'Ambiente' },
              { value: 'manifestado', label: 'Manifestado' },
            ]}
            label="Tipo"
            getValue={() =>
              setTimeout((value) => handleAutoSubmit('tipo')(value), 100)
            }
          /> */}
          <Combobox
            name="produto"
            label="nomeproduto"
            url="produtos"
            unique="idproduto"
            title={t('s.menu.configuracao.produto')}
            params={{
              wherefield: [],
              valuewherefield: [],
              typewherefield: [],
              fieldlist: 'idproduto, nomeproduto, tipoproduto',
            }}
            hiddens={[{ name: 'tipoproduto' }]}
            getValue={(value) => {
              if (value && value.idproduto) {
                setTimeout(() => handleAutoSubmit('produto')(value), 100);
              }
            }}
            setFirstValue={(options) => {
              if (Array.isArray(options) && options.size > 0) {
                setTimeout(() => handleAutoSubmit('produto')(options[0]), 100);
              }
            }}
          />
          <DateTime
            name="iniciomes"
            label={t('s.indicadoroperacao.iniciomes')}
            serialize={(value) => value.format('DD/MM/YYYY HH:mm:ss')}
            getValue={() =>
              setTimeout((value) => handleAutoSubmit('iniciomes')(value), 100)
            }
          />
          <DateTime
            name="inicioano"
            label={t('s.indicadoroperacao.inicioano')}
            serialize={(value) => value.format('DD/MM/YYYY HH:mm:ss')}
            getValue={() =>
              setTimeout((value) => handleAutoSubmit('inicioano')(value), 100)
            }
          />
        </S.WrapperForm>
      </Form>
    </S.Wrapper>
  );
}

Header.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  minimo: PropTypes.number,
  meta: PropTypes.number,
  maximo: PropTypes.number,
};

Header.defaultProps = {
  minimo: 0.4,
  meta: 0.2,
  maximo: 0.08,
};

export default Header;
